// This file contains all the scripts that must be loaded on page load
// This file should be excluded from Delay JS function in WP Rocket settings
// Scripts that can be delayed should go to main.js

document.addEventListener("DOMContentLoaded", function(event) {
  
/* Autoplay video when browser thread is idle
------------------------------------------------------------------------------*/

// Function to start autoplay when browser is idle
function startIdleAutoplay() {
  var idleVideos = document.querySelectorAll('video[data-autoplay-idle]');
  
  idleVideos.forEach(function(video) {
    // Use requestIdleCallback if available, otherwise setTimeout as fallback
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        loadAndPlayVideo(video);
      });
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(function() {
        loadAndPlayVideo(video);
      }, 3000);
    }
  });
}

// Function to load video from data-lazy-src and play it
function loadAndPlayVideo(video) {
  // First, load the video source if it hasn't been loaded yet
  if (video.dataset.lazySrc && !video.src) {
    video.src = video.dataset.lazySrc;
    video.load();
  }
  
  // Wait for video to be ready and then play
  if (video.readyState >= 3) { // HAVE_FUTURE_DATA
    video.play().catch(function(error) {
      console.log('Video autoplay failed:', error);
    });
  } else {
    // If video not ready, wait for it to load
    video.addEventListener('canplay', function() {
      video.play().catch(function(error) {
        console.log('Video autoplay failed:', error);
      });
    }, { once: true });
  }
}

// Start idle autoplay
startIdleAutoplay();

/* Lazy load for videos (based on https://web.dev/articles/lazy-loading-video )
------------------------------------------------------------------------------*/

// Select all video elements with the 'lazy' class
var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

if ("IntersectionObserver" in window) {
  // Create a new Intersection Observer
  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var video = entry.target;
        // Iterate through all video sources
        for (var source in video.children) {
          var videoSource = video.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            // Assign 'src' attribute from 'data-src'
            videoSource.src = videoSource.dataset.src;
          }
        }

        // Load the video
        video.load();
        // Add 'autoplay' attribute and start playback
        video.setAttribute('autoplay', 'true');
        video.play();
        // Remove 'lazy' class
        video.classList.remove("lazy");
        // Stop observing this element
        lazyVideoObserver.unobserve(video);
      }
    });
  });

  // Observe each video element
  lazyVideos.forEach(function(lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
}

/* CSS Animations observer - obserwuje wszystkie elementy z animacjami (except onload)
------------------------------------------------------------------------------*/

// Check if screen is large enough for animations (similar to AOS disable: 'mobile')
if ("IntersectionObserver" in window && window.innerWidth >= 1024) {
  
  // Wait for potential layout shifts to settle before starting observers
  function initializeAnimationObservers() {
    // Create a function to get observer with custom rootMargin for offset
    function getObserverForOffset(offset) {
      var rootMargin = '0px 0px ';
      
      if (offset) {
        // Convert offset to negative margin (AOS offset is trigger distance before element)
        rootMargin += '-' + (parseInt(offset) + 50) + 'px 0px';
      } else {
        rootMargin += '-50px 0px';
      }
      
      return new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var element = entry.target;
            
            // Additional checks to prevent false triggers from layout shifts
            var elementRect = element.getBoundingClientRect();
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            
            // More lenient validation - reduce buffer requirements
            // Only check if element is actually visible (not too close to very edge)
            var topBuffer = 50; // Reduced from 100px
            var bottomBuffer = 50; // Reduced from 100px
            
            var isElementVisible = elementRect.top < viewportHeight - bottomBuffer && elementRect.bottom > topBuffer;
            var elementHeight = elementRect.bottom - elementRect.top;
            
            // Debug info for problematic elements
            var isProblematicElement = element.textContent.includes('teasers__header') || element.classList.contains('teasers__header');
            if (isProblematicElement) {
              console.log('🔍 Debug teasers header:', {
                text: element.textContent.trim(),
                elementRect: elementRect,
                viewportHeight: viewportHeight,
                isElementVisible: isElementVisible,
                elementHeight: elementHeight,
                classes: element.className
              });
            }
            
            // Skip validation for very small elements or if element is clearly visible
            var skipValidation = elementHeight < 50 || (elementRect.top > 0 && elementRect.bottom < viewportHeight);
            
            if (isElementVisible || skipValidation) {
              
              // Add small delay to ensure layout stability
              setTimeout(function() {
                // Double-check element is still in valid position
                var finalRect = element.getBoundingClientRect();
                var isStillVisible = finalRect.top < viewportHeight && finalRect.bottom > 0;
                var alreadyAnimated = element.classList.contains('in-view');
                
                if (isStillVisible && !alreadyAnimated) {
                  
                  // Add in-view class directly to the element with data-anim
                  element.classList.add('in-view');
                  
                  // Debug info
                  console.log('✅ Animation triggered for:', element.textContent.trim().substring(0, 50) + '...', 'Type:', element.dataset.anim, 'offset:', element.dataset.animOffset);
                  
                  // Unobserve after triggering once
                  observer.unobserve(element);
                } else {
                  if (isProblematicElement) {
                    console.log('❌ Animation blocked for teasers header:', {
                      isStillVisible: isStillVisible,
                      alreadyAnimated: alreadyAnimated,
                      finalRect: finalRect
                    });
                  }
                }
              }, 50); // Small delay to ensure layout stability
            } else {
              if (isProblematicElement) {
                console.log('⚠️ Teasers header too close to edge:', {
                  elementRect: elementRect,
                  topBuffer: topBuffer,
                  bottomBuffer: bottomBuffer,
                  viewportHeight: viewportHeight
                });
              }
            }
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: rootMargin
      });
    }

    // Group elements by their offset value to minimize observers
    var offsetGroups = {};
    var animatedElements = document.querySelectorAll('[data-anim]:not([data-anim-onload])');
    console.log('Found animated elements:', animatedElements.length);
    
    // Special logging for teasers elements
    var teasersElements = document.querySelectorAll('[data-anim*="fade-up"][class*="teasers"]');
    if (teasersElements.length > 0) {
      console.log('🎯 Found teasers elements:', teasersElements.length);
      teasersElements.forEach(function(el) {
        console.log('Teasers element:', el.textContent.trim().substring(0, 30), el.dataset);
      });
    }
    
    animatedElements.forEach(function(element) {
      var offset = element.dataset.animOffset || '';
      
      if (!offsetGroups[offset]) {
        offsetGroups[offset] = {
          observer: getObserverForOffset(offset),
          elements: []
        };
      }
      
      offsetGroups[offset].elements.push(element);
    });
    
    // Start observing elements grouped by offset
    Object.keys(offsetGroups).forEach(function(offset) {
      var group = offsetGroups[offset];
      group.elements.forEach(function(element) {
        group.observer.observe(element);
      });
      console.log('Observer created for offset:', offset || 'default', 'watching', group.elements.length, 'elements');
    });
  }

  // Wait for layout to stabilize before initializing observers
  // Use multiple strategies for better coverage
  
  if (document.readyState === 'complete') {
    // Document already loaded, wait a bit more for any remaining layout shifts
    setTimeout(initializeAnimationObservers, 500);
  } else {
    // Wait for load event, then additional time for layout shifts
    window.addEventListener('load', function() {
      setTimeout(initializeAnimationObservers, 500);
    });
  }

  // Additional safeguard: reinitialize after fonts load (major cause of layout shift)
  if ('fonts' in document) {
    document.fonts.ready.then(function() {
      // Fonts loaded, wait a bit more then reinitialize if needed
      setTimeout(function() {
        // Only reinitialize if no observers are active yet
        var existingElements = document.querySelectorAll('[data-anim]:not([data-anim-onload]):not(.in-view)');
        if (existingElements.length > 0) {
          console.log('Reinitializing observers after fonts load');
          initializeAnimationObservers();
        }
      }, 200);
    });
  }
}

});